"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementsProps = void 0;
const react_1 = require("react");
function useElementsProps(iframeRef, adContent) {
    const [elementsProperties, setElementsProperties] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setElementsProperties(undefined);
    }, [adContent]);
    (0, react_1.useEffect)(() => {
        const onMessage = (event) => {
            if (event.source === (iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.contentWindow)) {
                let message = null;
                try {
                    message = JSON.parse(event.data);
                }
                catch (ignored) { }
                if (message &&
                    message.module === 'REVJET_Tag.Ad' &&
                    message.method === 'setElementsInitialized' &&
                    message.properties != null) {
                    setElementsProperties(message.properties);
                }
            }
        };
        window.addEventListener('message', onMessage, false);
        return () => window.removeEventListener('message', onMessage, false);
    }, [iframeRef]);
    return elementsProperties;
}
exports.useElementsProps = useElementsProps;
//# sourceMappingURL=use-elements-props.js.map